import React, { useRef, useEffect } from "react";


import { debounce } from "utils";
import m from "definedMessages";
import { useWindowWidth } from "hooks";
import FormHOC from "hoc/FilltersForm";
import { clearFormRef } from "utils/helpers";
import { LOCAL_STORAGE_CLI_FILTERS_DIALER } from "const";
import { BaseInputField } from "components/base/BaseForm";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";
import CustomSelfClearedForm from "components/client/Form/CustomSelfClearedForm";

import { Form, Schema } from "rsuite";

const { StringType } = Schema.Types;

const MAX_LENGTH = 17;

const hocFiltersModel = Schema.Model({
    str: StringType("Please enter a valid string")
        // .minLength(MIN_LENGTH, `The minimum of this field is ${MIN_LENGTH} digits`)
        .maxLength(MAX_LENGTH, `The maximum of this field is ${MAX_LENGTH} digits`)
        .isRequired("This field is required")
});


export default FormHOC(({
    service,
    loading,
    onChangeFilter,
    defaultFilter,
    savedTableFilter,

    formatMessage
}) => {
    const resizedWidth = useWindowWidth();

    const filterRef = useRef(null);

    const MANAGABLE_MIN_LENGTH = service ? 6 : 3;

    const filtersModelInner = Schema.Model({
        str: StringType(formatMessage(m.pleaseEnterValidString))
            .minLength(MANAGABLE_MIN_LENGTH, formatMessage(m.minLengthDigits, { count: MANAGABLE_MIN_LENGTH }))
            .maxLength(MAX_LENGTH, formatMessage(m.maxLengthDigits, { count: MAX_LENGTH }))
            .isRequired(formatMessage(m.thisFieldIsRequired))
    }
    );

    useEffect(() => {
        clearFormRef(filterRef, true);
        localStorage.removeItem(LOCAL_STORAGE_CLI_FILTERS_DIALER);
    }, [service]);

    const onSubmit = (data, checkedData) => {
        const checker = Object.keys(checkedData).map(i => checkedData[i].hasError).every(value => value === false);

        if (checker) {
            onChangeFilter(data);
        }
        return false;
    };

    const filterMessage = service
        ? (resizedWidth > 300 ? formatMessage(m.putYourCliMin, { count: MANAGABLE_MIN_LENGTH }) : formatMessage(m.putYourCli))
        : (resizedWidth > 300 ? formatMessage(m.putSenderIdMin, { count: MANAGABLE_MIN_LENGTH }) : formatMessage(m.putSenderId))

    return (
        <CustomSelfClearedForm
            ref={filterRef}
            clearOn={service}
            model={filtersModelInner}
            // formDefaultValue={savedTableFilter || {}}
            formDefaultValue={defaultFilter}
            onChange={debounce((data) => {
                const checkedData = filtersModelInner.check(data);
                onSubmit(data, checkedData);
            }, 500)}
            fluid
            readOnly={loading}
        >
            <FlexGrid align="top">
                <FlexGridItem width="320px">
                    <Form.Control
                        name="str"
                        accepter={BaseInputField}
                        errorPlacement="topEnd"
                        placeholder={filterMessage}
                    // value={filterState}
                    // onChange={(data) => {
                    //     onChangeFilterState(data);
                    // }}
                    />
                </FlexGridItem>
            </FlexGrid>
        </CustomSelfClearedForm>
    );
}, hocFiltersModel, 500);